/* eslint-disable */
import api from '@/utils/backend-api'

export default {
  namespaced: true,
  state: {
    Products: ''
  },
  mutations: {
    setProductsData (state, {Products}) {
      state.Products = Products
    },
    reset (state) {
      state.Products = ''
    }
  },
  actions: {
    getAllProducts ({commit}) {
      return new Promise(function (resolve, reject) {
        api.postData('auth/driver/products')
        .then((response) => {
          var Products = response.data
          commit('setProductsData', {Products})
          resolve(Products)
        }).catch((error) => {
          reject(error)
        })
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Products.js